export const selectors = {
  objFiles: (state) => state.viewer.objFiles,
  pngFiles: (state) => state.viewer.pngFiles,
  jsonFile: (state) => state.viewer.jsonFile,
  params: (state) => state.viewer.params,
};
